
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"
import { ProjectManagerProjectDropdown } from "src/components/projectManagerProjectDropdown";
import _ from 'lodash';
import { setSelectedProjectDropdownValue } from "src/thunks/goodsin";
import { getMyData } from "src/thunks/auth";
import { toast } from "react-toastify";
import { GetError, getFloatValue } from "src/constant";
import './dashboard.scss';
import MstBerger from "src/layouts/components/projectManagerHeaders/mstBurger";
import { ProjectManagerClientDropdown } from "src/components/projectManagerClientDropdown";
import { useLocation } from "react-router-dom";
import { setSelectedProjectManagerDashboardDropdownValues } from "src/thunks/dashboard";



function ProjectManagerDashboardHeader({ RightSidebarOpenCloseFlag }) {
  // Useselector
  const dispatch = useDispatch();
  const clientProjects = useSelector((state) => state?.clientProjects?.clientProject);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);

  // UseState
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [projectArrayShown, setProjectArrayShown] = useState([]);
  const [filterData, setFilterData] = useState({});

  //Variable Declarations
  let parsedProjectManagerObject = userDetails;
  const filterProjectBasedOnClientId = _.filter(parsedProjectManagerObject?.projects, (d) => d.clientId == filterData?.clientId?.id);
  const indClientTotalItemsCount = _.sumBy(filterProjectBasedOnClientId || [], d => d?.itemSummary?.count || 0);
  const indClientDamagedItemsCount = _.sumBy(filterProjectBasedOnClientId || [], d => d?.itemSummary?.damagedCount || 0);
  const indClientIntOccupiedSpaceCount = getFloatValue(_.sumBy(filterProjectBasedOnClientId || [], d => d?.itemSummary?.interiorOccupiedSpace || 0));
  const indClientExtOccupiedSpaceCount = getFloatValue(_.sumBy(filterProjectBasedOnClientId || [], d => d?.itemSummary?.exteriorOccupiedSpace || 0));
  const allClientsTotalItemsCount = _.sumBy(parsedProjectManagerObject?.projects || [], d => d?.itemSummary?.count || 0);
  const allClientsDamagedItemsCount = _.sumBy(parsedProjectManagerObject?.projects || [], d => d?.itemSummary?.damagedCount || 0);
  const allClientsTotalIntOccupiedSpaceCount = getFloatValue(_.sumBy(parsedProjectManagerObject?.projects || [], d => d?.itemSummary?.interiorOccupiedSpace || 0));
  const allClientsTotalExtOccupiedSpaceCount = getFloatValue(_.sumBy(parsedProjectManagerObject?.projects || [], d => d?.itemSummary?.exteriorOccupiedSpace || 0))


  // Useeffect
  useEffect(() => {
    dispatch(setSelectedProjectManagerDashboardDropdownValues({ ...filterData }))
  }, []);

  useEffect(() => {
    getAllMyData()
  }, [])

  // Function Declarations
  const allFilterChange = (label, value) => {
    let changeData = {
      ...filterData,
      [label]: value,
    };
    if (label == "clientId") {
      delete changeData?.projectId
    }
    dispatch(setSelectedProjectManagerDashboardDropdownValues({ ...changeData }))
    setFilterData({ ...changeData });
  }


  const getAllMyData = async () => {
    try {
      let res = await dispatch(getMyData()).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    } finally {
    }
  };

  useEffect(() => {
    const combinedArray = [...parsedProjectManagerObject?.projects];
    setProjectArrayShown([...combinedArray])
  }, [])


  // const handleProjectChange = (label) => {
  //   setProjectGoodsInDropdownvalue(label);
  // };

  return (
    <>
      <div className="pm-dashboard">
        <MstBerger />
        <div className="container-fluid ">
          <div className="row align-items-center">
            <div className="col-4 col-sm-3 col-md-2 col-lg-1">
              <img src={SigmaLogo} alt="muz image" width={90} />
            </div>
            <div className="col-12 col-sm-6 col-md-2 col-lg-1 mt-3 mt-sm-0 text-center text-sm-start">
              <span className="text-uppercase project-name-projectMgnr-dashboard-style">{moment().format('DD-MMM-YYYY')}</span>
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
              <ProjectManagerClientDropdown
                handleChange={(value) => allFilterChange("clientId", value)}
                clientGoodsInDropdownValue={
                  filterData?.clientId || { id: 0, name: "ALL CLIENTS" }
                }
              />
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
              <ProjectManagerProjectDropdown
                clientId={filterData?.clientId}
                handleChange={(value) => allFilterChange("projectId", value)}
                projectGoodsInDropdownValue={
                  filterData?.projectId || { id: 0, name: "ALL PROJECTS" }
                }
              />
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-2">
              <div className="d-flex justify-content-center justify-content-sm-end justify-content-md-start justify-content-lg-end py-2 py-lg-0">
                <div className="me-4">
                  <span className="project-name-projectMgnr-dashboard-style">{filterData?.clientId?.id && !filterData?.projectId ? indClientTotalItemsCount : filterData?.projectId?.id ? filterData?.projectId?.itemSummary?.count : allClientsTotalItemsCount || 0}</span>
                  <span className="count-label-pm-dashboard-style ms-1">ITEMS</span>
                </div>
                <div>
                  <span className="project-name-projectMgnr-dashboard-style">{filterData?.clientId?.id && !filterData?.projectId ? indClientDamagedItemsCount : filterData?.projectId?.id ? filterData?.projectId?.itemSummary?.damagedCount : allClientsDamagedItemsCount || 0}</span>

                  <span className="count-label-pm-dashboard-style ms-1">DAMAGED</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-8 col-lg-4">
              <p className="m-0 text-center text-md-end py-2 py-lg-0">
                <span className="project-name-projectMgnr-dashboard-style">{filterData?.clientId?.id && !filterData?.projectId ? getFloatValue(indClientIntOccupiedSpaceCount) : filterData?.projectId?.id ? getFloatValue(filterData?.projectId?.itemSummary?.interiorOccupiedSpace) : allClientsTotalIntOccupiedSpaceCount} m<sup>2</sup> [Int] /{filterData?.clientId?.id && !filterData?.projectId ? getFloatValue(indClientExtOccupiedSpaceCount) : filterData?.projectId?.id ? getFloatValue(filterData?.projectId?.itemSummary?.exteriorOccupiedSpace) : allClientsTotalExtOccupiedSpaceCount} m<sup>2</sup> [Ext] </span>
                <span className="count-label-pm-dashboard-style">OCCUPIED</span>
              </p>
            </div>
          </div>
        </div>
        {/* <div className={` ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""} d-flex align-items-center main-header-div`}>
          <div className="d-flex align-items-center" style={{ flex: 10 }}>
            <div style={{ flex: 1}} className="ms-2">
              <img width={90} height={35} src={SigmaLogo} alt="muz image" />
            </div>
            {parsedProjectManagerObject?.projects[0]?.clientLogoUrl ?
              <div className="d-flex justify-content-center" style={{ flex: 1.4}}>
                <div className="clientlogo-container" >
                <img className="img-client-logo" src={parsedProjectManagerObject?.projects[0]?.clientLogoUrl || ""} alt="client name"></img>
                </div>
              </div>
              :
              <div style={{ flex: 1.4 }}>
                <span className="project-name-projectMgnr-dashboard-style dashboardclientname-value-style">{parsedProjectManagerObject?.projects[0]?.clientName || ""}</span>
              </div>}
            <div style={{ flex: 1.1 }}>
              <span className="text-uppercase project-name-projectMgnr-dashboard-style">{moment().format('DD-MMM-YYYY')}</span>
            </div>
            <div style={{ flex: 2, color: "white" }}>
              <ProjectManagerProjectDropdown ProjectData={projectArrayShown} handleChange={(value) => handleProjectChange(value)} projectGoodsInDropdownValue={projectGoodsInDropdownValue} />
            </div>
            <div style={{ flex: 0.7 }}>
              <span className="project-name-projectMgnr-dashboard-style">{projectGoodsInDropdownValue?.name == "ALL PROJECTS" ? totalItemsCount : projectGoodsInDropdownValue?.itemSummary?.count || 0}</span>
              <span className="count-label-pm-dashboard-style ms-1">ITEMS</span>
            </div>
            <div style={{ flex: 0.9 }}>
              <span className="project-name-projectMgnr-dashboard-style">{projectGoodsInDropdownValue?.name == "ALL PROJECTS" ? damagedItemsCount : projectGoodsInDropdownValue?.itemSummary?.damagedCount || 0}</span>
              <span className="count-label-pm-dashboard-style ms-1">DAMAGED</span>
            </div>
            <div style={{ flex: 2.9,textAlign:"end",paddingRight:10 }}>
              <span className="project-name-projectMgnr-dashboard-style">{projectGoodsInDropdownValue?.name == "ALL PROJECTS" ? getFloatValue(intOccupiedSpaceCount) : getFloatValue(projectGoodsInDropdownValue?.itemSummary?.interiorOccupiedSpace)} m<sup>2</sup> [Int] /{projectGoodsInDropdownValue?.name == "ALL PROJECTS" ? getFloatValue(extOccupiedSpaceCount) : getFloatValue(projectGoodsInDropdownValue?.itemSummary?.exteriorOccupiedSpace)} m<sup>2</sup> [Ext] </span>
              <span className="count-label-pm-dashboard-style">OCCUPIED</span>

            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default ProjectManagerDashboardHeader;
